import React from "react";
import AddCamionForm from "./AddCamionForm";

const AddCamion = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };

  return (
    <>
      <div>
        <button
          className="btn btn-dark"
          onClick={handleShow}
        >
          {show
            ? "Ocultar formulario"
            : "Agregar vehículo"}
        </button>
      </div>

      {show && (
        <div className="mt-3">
          <AddCamionForm setShow={setShow} />
        </div>
      )}
    </>
  );
};

export default AddCamion;